enum RegistrationStatus {
    PENDING = 'statusPending',
    SUCCESS = 'statusSuccess',
    FAILED = 'statusFailed',
    PASSWORD_WEAK = 'passwordWeak',
    EMAIL_IN_USE = 'emailInUse'
}

export default RegistrationStatus
